module.exports = __webpack_public_path__ + "img/card-discover.1783ea2b.svg";